__turbopack_context__.v({
  "root": "Icon-module-scss-module__nObmlG__root",
});
